import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import StreamgraphChart from './components/StreamgraphChart'
import StreamgraphChart2 from './components/StreamgraphChart2'
import { HeaderChartProps, mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import SourceLink from '../../component/chartLinkData'

interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  const [showSeasonModal, setShowSeasonModal] = useState(false)
  const [selectedAgeClass, setSelectedAgeClass] = useState<string[]>(['0-200'])
  const [selectedDiagnosisCategories, setSelectedDiagnosisCategories] = useState<string>('all_resp_diags')
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const HeaderChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      Hospital admissions of patients with a diagnosis of respiratory syndromes {season} (France
      - Lyon){' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              The graph displays the number of hospital admissions for respiratory
              infections in Lyon area (weekly counts from Hospices Civils de Lyon).
              Nowcasting estimator of the numbers is preprocessed to account for
              potential reporting delay. Hospital admissions can be further classified
              by age group and specific types of respiratory infections, including
              influenza, RSV, SARS-CoV-2, other viral respiratory infections. The alert
              threshold is based on historical data.
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderChart />
              </div>
              <Card.Body className='row ' style={{ marginTop: '-35px' }}>
                <StreamgraphChart
                  season={mainSeason}
                  selectedAgeClass={selectedAgeClass}
                  setSelectedAgeClass={setSelectedAgeClass}
                  selectedDiagnosisCategories={selectedDiagnosisCategories}
                  setSelectedDiagnosisCategories={setSelectedDiagnosisCategories}
                />
                <p className='card-text source'>
                  <p className='card-text source mt-2 row'>
                    <i style={{ fontSize: '12px' }} className=''>
                      * The baseline represents the smoothed value from the corresponding week of the previous year. When historical data is unavailable, current year values are used as fallback. Confidence intervals are calculated by determining the critical value using the normal distribution corresponding to a 95% confidence level. The standard deviation is multiplied by this critical value to obtain the margins of error, which are then added and subtracted from the sample mean to define the interval bounds. The computed alert corresponds to a binary value of 0/1 for each week, diagnosis, age group, geographical origin or/and RSS duration. It indicates, when equal to 1, that the current case count exceeds the upper bound of the baseline case count.
                    </i>
                  </p>
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source row'>
                    <i>
                      Source:
                      <a className='fw-bold' href='https://www.chu-lyon.fr'>
                        {' '}
                        Hospices Civils de Lyon
                      </a>{' '}
                      , Résumés de Sortie Standardisés (RSS)
                    </i>
                  </p>
                  <SourceLink onClick={() => setShowSeasonModal(true)} />
                </div>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
      <Modal
        // size="xl"
        className="modal-xxl"
        show={showSeasonModal}
        onHide={() => setShowSeasonModal(false)}
        centered
      >
        <Modal.Header closeButton className='py-4'>
          <Modal.Title>
            <HeaderChart season={'2023-2024'} />
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <StreamgraphChart
            season={modalSeason}
            selectedAgeClass={selectedAgeClass}
            setSelectedAgeClass={setSelectedAgeClass}
            selectedDiagnosisCategories={selectedDiagnosisCategories}
            setSelectedDiagnosisCategories={setSelectedDiagnosisCategories}
          />
          <p className='card-text source'>
            <p className='card-text source mt-2 row'>
              <i style={{ fontSize: '12px' }} className=''>
                * The baseline represents the smoothed value from the corresponding week of the previous year. When historical data is unavailable, current year values are used as fallback. Confidence intervals are calculated by determining the critical value using the normal distribution corresponding to a 95% confidence level. The standard deviation is multiplied by this critical value to obtain the margins of error, which are then added and subtracted from the sample mean to define the interval bounds. The computed alert corresponds to a binary value of 0/1 for each week, diagnosis, age group, geographical origin or/and RSS duration. It indicates, when equal to 1, that the current case count exceeds the upper bound of the baseline case count.
              </i>
            </p>
          </p>
          <div className="d-flex justify-content-between align-items-center">
            <p className='card-text source row'>
              <i>
                Source:
                <a className='fw-bold' href='https://www.chu-lyon.fr'>
                  {' '}
                  Hospices Civils de Lyon
                </a>{' '}
                , Résumés de Sortie Standardisés (RSS)
              </i>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

const DashboardPage2 = () => {
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <h2 className='text-primary bold'>
                  {' '}
                  Hospital admissions of patients with a diagnosis of respiratory syndromes (France
                  – Vivalto Santé hospital network){' '}
                  <OverlayTrigger
                    placement='right'
                    overlay={
                      <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
                        <p>
                          The graph displays the number of hospitals admission for respiratory
                          infections in Vivalto Santé private hospital network (weekly counts).
                          Nowcasting estimator of the numbers is preprocessed to account for
                          potential reporting delay. Breakdown by age group and type of respiratory
                          infections, including influenza, RSV, SARS-CoV-2, other viral respiratory
                          infections is available.
                        </p>
                      </Tooltip>
                    }
                  >
                    <img
                      //className='mb-1'
                      style={{ width: '12px' }}
                      alt='logo'
                      src={toAbsoluteUrl('/media/logos/ii.svg')}
                    />
                  </OverlayTrigger>
                </h2>
              </div>
              <Card.Body className='row ' style={{ marginTop: '-35px' }}>
                <StreamgraphChart2 />
                <p className='card-text source'>
                  <p className='card-text source mt-2 row'>
                    <i style={{ fontSize: '12px' }} className='mb-2'>
                      * The baseline represents the smoothed value from the previous year.
                      Confidence intervals are calculated by determining the critical value using
                      the normal distribution corresponding to a 95% confidence level. The standard
                      deviation is multiplied by this critical value to obtain the margins of error,
                      which are then added and subtracted from the sample mean to define the
                      interval bounds. The computed alert corresponds to a binary value of 0/1 for
                      each week, diagnosis, age group, geographical origin or/and RSS duration. It
                      indicates, when equal to 1, that the current case count exceeds the upper
                      bound of the baseline case count.
                    </i>
                    <i>
                      Source:
                      <a className='fw-bold' href='https://www.vivalto-sante.com'>
                        {' '}
                        Vivalto Santé
                      </a>
                    </i>{' '}
                  </p>
                </p>
              </Card.Body>
            </div>
          </Card>
        </div>
      </div>
    </>
  )
}

const HospitalAdmissions = () => {
  const intl = useIntl()
  return (
    <>
      <div className='mb-5'>
        <DashboardPage />
      </div>
      <div className='mb-5'>
        {/* <DashboardPage2 /> */}
      </div>
    </>
  )
}

export { HospitalAdmissions }
